// eslint-disable-next-line import/named
import { baseUrl } from "./baseUrl";
import buildUrl from "../utils/buildUrl";

export const getPaymentsNewRoute = (params) =>
  buildUrl({
    url: `${baseUrl}/payments-api/payments/pageable-search`,
    searchParams: params,
  });

export const getPaymentsRoute = (...params) => [`${baseUrl}`, "payments-api", ...params].join("/");

export const paymentsSearchRoute = (searchParams) =>
  buildUrl({
    url: [baseUrl, "payments-api", "payments", "search"].join("/"),
    searchParams,
  });

export const transferBalanceRoute = () =>
  buildUrl({
    url: [baseUrl, "processes-api", "processes", "balance-transfer"].join("/"),
  });

export const paymentCoverBillsRoute = () =>
  [`${baseUrl}`, "payments-api", "payments", "cover-goal-bills"].join("/");

export const paymentUncoverBillsRoute = () =>
  [`${baseUrl}`, "payments-api", "payments", "uncover-bills"].join("/");

export const paymentUncoverByInvoiceIdsRoute = () =>
  `${baseUrl}/payments-api/payments/uncover-if-need-invoices`;

export const paymentUncoverByTaxInvoiceIdsRoute = () =>
  `${baseUrl}/payments-api/payments/uncover-taxinvoices`;

export const paymentRegisterRoute = () =>
  [`${baseUrl}`, "payments-api", "payments", "create-from-raw"].join("/");
